import {Routes, Route, useLocation} from "react-router-dom";
import React, {useEffect, useMemo} from "react";
import * as pages from "pages/client";
import {ScreenId} from "@assets";
import {useSetRecoilState} from "recoil";
import {states} from "@recoils";
import {useLogin} from "@hook";

interface IRoute {
  path: ScreenId;
  element: JSX.Element;
  isLogin?: boolean;
}

const initRouteList: IRoute[] = [
  {path: ScreenId.HOME, element: <pages.HomePage />},
  {path: ScreenId.ABOUT, element: <pages.AboutPage />, isLogin: true},
  {path: ScreenId.ORGANIC, element: <pages.OrganicPage />, isLogin: true},
  {path: ScreenId.NOTICE, element: <pages.NoticePage />, isLogin: true},
  {
    path: ScreenId.NOTICE_DETAIL,
    element: <pages.NoticeDetailPage />,
    isLogin: true,
  },
  {path: ScreenId.MEMBER, element: <pages.MemberPage />, isLogin: true},
  {path: ScreenId.LOGIN, element: <pages.LoginPage />},
  {path: ScreenId.KAKAO_LOGIN_CALLBACK, element: <pages.KakaoCallbackPage />},
];

export default function WebRouteApp() {
  const {userData} = useLogin();
  const location = useLocation();
  const setPathState = useSetRecoilState(states.pathState);

  const routeList = useMemo(() => {
    if (userData?.confirm === "1") {
      return initRouteList;
    }
    return initRouteList.map(item =>
      item.isLogin ? {...item, element: <pages.LoginPage />} : item,
    );
  }, [userData]);

  useEffect(() => {
    setPathState(location.pathname as ScreenId);
  }, [location.pathname]);

  return (
    <Routes>
      <Route
        path="/"
        element={(routeList || [])[0]?.element || <pages.HomePage />}
      />
      {routeList.map((_route, i) => (
        <Route key={i} path={_route.path} element={_route.element} />
      ))}
      <Route path="*" element={<pages.LoginPage />} />
    </Routes>
  );
}
